<template>
	<div>
		<div>

			<div v-if="!userId">
				<el-row class="box_5">
					<!-- <el-col :span="4"> -->
					<el-col :xs="6" :sm="1" :md="1" :lg="4" :xl="4" class="nav-col-l">
						<img class="hidden-md-and-down" style="height: 40px;margin: 0 0 0 140px;" referrerPolicy="no-referrer"
							src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/logo/logo.svg" @click="homeClick" />
						<img class="hidden-sm-and-up nav-logo" referrerpolicy="no-referrer"
							src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/logo/logo-l.png" />
					</el-col>


					<el-col :xs="14" :sm="21" :md="19" :lg="16" :xl="16" class="nav-col">
						<el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" class="my-menu"
							text-color="#666" active-text-color="#1677ff" router>
							<!-- <el-menu-item index="/" v-if="screenWidth >= 767 || activeIndex === '/'"
								:style="{ 'width': screenWidth < 767 && activeIndex === '/' ? '100%' : 'auto' }">
								首页
							</el-menu-item>
							<el-menu-item index="/shutong" v-if="screenWidth >= 767 || activeIndex === '/shutong'"
								:style="{ 'width': screenWidth < 767 && activeIndex === '/shutong' ? '100%' : 'auto' }">
								极光数通
							</el-menu-item>
							<el-menu-item index="/apiList" v-if="screenWidth >= 767 || activeIndex === '/apiList'"
								:style="{ 'width': screenWidth < 767 && activeIndex === '/apiList' ? '100%' : 'auto' }">
								极光天启
							</el-menu-item>
							<el-menu-item index="/guanyuwomen" v-if="screenWidth >= 767 || activeIndex === '/guanyuwomen'"
								:style="{ 'width': screenWidth < 767 && activeIndex === '/guanyuwomen' ? '100%' : 'auto' }">
								关于我们
							</el-menu-item> -->


							<!-- <el-submenu index="more" v-if="screenWidth >= 767"
								:style="{ 'width': screenWidth < 767 && (activeIndex === '/chanpin/hujiaozhongxin' || activeIndex === '/chanpin/duanxinyingxiao' || activeIndex === '/chanpin/guanggaozhushou') ? '100%' : 'auto' }">
								<template slot="title">产品解决方案</template>
								<el-menu-item index="/chanpin/hujiaozhongxin">
									呼叫中心解决方案
								</el-menu-item>
								<el-menu-item index="/chanpin/duanxinyingxiao">
									短信解决方案
								</el-menu-item>
								<el-menu-item index="/chanpin/guanggaozhushou">
									广告助手解决方案
								</el-menu-item>
							</el-submenu>
							<el-menu-item class="my-menu-disabled" disabled
								v-if="screenWidth < 767 && (activeIndex === '/chanpin/hujiaozhongxin' || activeIndex === '/chanpin/duanxinyingxiao' || activeIndex === '/chanpin/guanggaozhushou')"
								:style="{ 'width': '100%' }">
								产品解决方案
							</el-menu-item> -->
							<!-- <el-menu-item index="/zhaoshangqudao"
								v-if="screenWidth >= 767 || activeIndex === '/zhaoshangqudao'"
								:style="{ 'width': screenWidth < 767 && activeIndex === '/zhaoshangqudao' ? '100%' : 'auto' }">
								招商渠道
							</el-menu-item>
							<el-menu-item index="/jiage" v-if="screenWidth >= 767 || activeIndex === '/jiage'"
								:style="{ 'width': screenWidth < 767 && activeIndex === '/jiage' ? '100%' : 'auto' }">
								&nbsp;&nbsp;价格&nbsp;&nbsp;
							</el-menu-item> -->


							<el-menu-item index="/" v-if="screenWidth >= 767 || activeIndex === '/'"
								:style="{ 'width': screenWidth < 767 && activeIndex === '/' ? '100%' : 'auto' }">
								首页
							</el-menu-item>
							<el-submenu index="/hexinchanpin" v-if="screenWidth >= 767 || activeIndex === '/hexinchanpin'"
										:style="{ 'width': screenWidth < 767 && activeIndex === '/hexinchanpin' ? '100%' : 'auto' }">
								<template slot="title">核心产品</template>
<!--								<el-menu-item index="/hexinchanpin">星海DPI大数据</el-menu-item>-->
								<el-menu-item index="/car">汽车罗盘大数据</el-menu-item>
								<el-menu-item index="/shujuchanpin">天启API大数据</el-menu-item>
							</el-submenu>
<!--              <el-menu-item index="/shujuchanpin" v-if="screenWidth >= 767 || activeIndex === '/shujuchanpin'"-->
<!--                            :style="{ 'width': screenWidth < 767 && activeIndex === '/shujuchanpin' ? '100%' : 'auto' }">-->
<!--                数据产品-->
<!--              </el-menu-item>-->

              <el-menu-item index="/apiMall" v-if="screenWidth >= 767 || activeIndex === '/apiMall'"
                            :style="{ 'width': screenWidth < 767 && activeIndex === '/apiMall' ? '100%' : 'auto' }">
                API集市
              </el-menu-item>
							<el-menu-item index="news" @click.native="goNews" v-if="screenWidth >= 767"
								:style="{ 'width': 'auto' }">行业资讯</el-menu-item>

							<el-menu-item index="/about" v-if="screenWidth >= 767 || activeIndex === '/about'"
								:style="{ 'width': screenWidth < 767 && activeIndex === '/about' ? '100%' : 'auto' }">
								关于我们
							</el-menu-item>
						</el-menu>
					</el-col>






					<el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="4" style="display: flex;justify-content: flex-end;">
						<div class="text-wrapper_2 flex-col" @click="handleOpen"><span class="text_4">登录</span></div>
						<div class="text-wrapper_3 flex-col" @click="handleOpen"><span class="text_5">免费试用</span></div>
						<el-dropdown trigger="click" placement="bottom-end" id="bars" class="nav-drop-down">
							<span>菜单</span>
							<i class="el-icon-caret-bottom"></i>
							<el-dropdown-menu slot="dropdown" class="nav-dropdown-menu">
								<el-dropdown-item @click.native="handleOpen" class="nav-dropdown-item">
									<span>登录</span>
								</el-dropdown-item>

								<el-dropdown-item divided @click.native="changePanel('/')" class="nav-dropdown-item">
									<span>首页</span>
								</el-dropdown-item>

								<!-- <el-dropdown-item @click.native="changePanel('/chanpin/hujiaozhongxin')"
									class="nav-dropdown-item">
									<span>呼叫中心解决方案</span>
								</el-dropdown-item>

								<el-dropdown-item @click.native="changePanel('/chanpin/duanxinyingxiao')"
									class="nav-dropdown-item">
									<span>短信解决方案</span>
								</el-dropdown-item>

								<el-dropdown-item @click.native="changePanel('/chanpin/guanggaozhushou')"
									class="nav-dropdown-item">
									<span>广告助手解决方案</span>
								</el-dropdown-item> -->

								<el-dropdown-item @click.native="changePanel('/shutong')" class="nav-dropdown-item">
									<span>极光数通</span>
								</el-dropdown-item>

								<el-dropdown-item @click.native="changePanel('/tianqi')" class="nav-dropdown-item">
									<span>极光天启</span>
								</el-dropdown-item>

								<el-dropdown-item @click.native="goNews" class="nav-dropdown-item">
									<span>行业资讯</span>
								</el-dropdown-item>

								<!-- <el-dropdown-item @click.native="changePanel('/jiage')" class="nav-dropdown-item">
									<span>价格</span>
								</el-dropdown-item>

								<el-dropdown-item @click.native="changePanel('/zhaoshangqudao')" class="nav-dropdown-item">
									<span>招商渠道</span>
								</el-dropdown-item> -->

								<el-dropdown-item @click.native="changePanel('/guanyuwomen')" class="nav-dropdown-item">
									<span>关于我们</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-col>
				</el-row>
			</div>

			<div v-else class="sidebar">
				<SideBar></SideBar>
			</div>

			<div v-if="userId" class="header">

				<img class="image_5" referrerPolicy="no-referrer" src="https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/logo/logo.svg" @click="homeClick" />
				<el-popover class="xhl" placement="bottom" width="500" trigger="hover" offset="0" @show="handleSearch">
					<el-table v-loading="tableLoading" :show-header="false" :data="xhl_data" size="">
						<el-table-column width="300" property="a" label="" align="center"></el-table-column>
						<el-table-column width="100" property="b" label="" align="center"></el-table-column>
						<el-table-column width="100" property="c" label="" align="center"></el-table-column>

					</el-table>
					<span class="xsl-ps">注:上期余量不会累积到下期,建议当期使用完毕。(以1年为周期)</span>
					<i slot="reference" class="el-icon-data-line">消耗量</i>
				</el-popover>

				<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
					<div class="avatar-wrapper">
						<!-- <img v-if="avatar != ''" :src="avatar" class="user-avatar"> -->
						<!-- <el-avatar shape="square" fit="fill" :src="avatar != '' ? avatar : squareUrl"></el-avatar> -->
						<div class="user-avatar"
							style="background: #4B64D9; text-align: center; font-size: 18px; color: #fff;">
							{{ userInfo.nickname ? userInfo.nickname.charAt(0) : name ? name.charAt(0) : '秘' }}
						</div>
						<span class="user-name">{{ userInfo.nickname ? userInfo.nickname : name ? name : '神秘人' }}<i
								class="el-icon-caret-bottom"></i></span>
					</div>
					<el-dropdown-menu slot="dropdown" class="lang-select-dropdown">
						<router-link to="/personalCenter">
							<el-dropdown-item>个人中心</el-dropdown-item>
						</router-link>

						<el-dropdown-item @click.native="updatePassword">
							<span>修改密码</span>
						</el-dropdown-item>

						<router-link to="/message">
							<el-dropdown-item>消息中心</el-dropdown-item>
						</router-link>

						<el-dropdown-item divided @click.native="logout">
							<span>退出登录</span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>

		<LoginPublic :dialogVisible="dialogVisibles" @handleClose="closeDialog" />

		<ChangePassword :changePasswordVisible="changePasswordVisibles" @handlePasswordClose="closePasswordDialog" />

	</div>
</template>

<script>
import { getUeage } from '../api/usage.js';
import { queryCustLeadsPage,queryUserList } from '../api/crm/pool.js';
import { dataPage } from '../api/customerPool.js'
import { listUser } from '../api/crm/user.js'
import LoginPublic from './login-public.vue'
import SideBar from '@/components/sidebar/sidebar.vue'
import ChangePassword from '../views/user/changePassword.vue'
import { mapActions, mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import { getToken } from '@/utils/auth'
import 'element-ui/lib/theme-chalk/display.css';
import { getTenant } from '../api/tenant'
import { formatDateN } from '../utils/toolUtils.js'
import { checkBalance } from "@/api/ocpc/apiBill";

export default {
	components: {
		LoginPublic,
		ChangePassword,
		SideBar
	},
	data() {
		return {
			activeIndex: '/',
			logo: 'https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/logo/logo.png',
			avatar: '',
			squareUrl: 'https://jg-cust.obs.cn-east-3.myhuaweicloud.com/cust/static/logo/square.png',
			name: '',
			dialogVisibles: false,
			changePasswordVisibles: false,
			userId: '',
			dropDownShow: false, // 控制下拉菜单显示
			screenWidth: 0,
			tableLoading: false,
			xhl_data: [
				{a:'本年企业消耗/总线索量',b:'222'},
				{a:'本月企业消耗/总线索量',b:'444'},
				{a:'本日企业消耗/总线索量',b:'666'},
				{a:'本年个人消耗/总线索量',b:'666'},
				{a:'本月个人消耗/总线索量',b:'666'},
				{a:'本日个人消耗/总线索量',b:'666'},
			],
			dqsj:'',
			pageSize: 10,
			//第几页
			pageNum: 1,
			dayUnlockCount:'',
			maxCustCount:'',
			expireTime:'',
			total:'',
			total1:'',
			// 存储企业下账号数量
			qiyexizhanghugeshu:'',
		}
	},
	mounted() {
		this.dialogVisibles = false;
		this.changePasswordVisibles = false;
		this.avatar = Cookies.get("avatar");
		this.name = Cookies.get("name");
		this.userId = Cookies.get("userId");
		// console.log(this.userInfo)

		this.handleResize();
		window.addEventListener('resize', this.handleResize);
	},

	computed: {
		...mapGetters(['userInfo'])
	},

	created() {
		this.onRouteChanged();
		if(this.$store.getters.token!=null){
			this.checkBalance();
			this.handleSearch();
		}
	},
	watch: {
		$route: 'onRouteChanged'
	},

	methods: {
		...mapActions([
			'LogOut',
		]),

		checkBalance() {
			checkBalance().then((res) => {
				if(!!res.data && res.data.balance <= res.data.warnBalance) {
					this.$notify({
						title: '提示',
						message: '当前余额已达到预警值: '+res.data.warnBalance+'元, 请联系相关商务进行充值。',
						type: 'warning',
						duration: 0
					});
				}
			})
		},
		homeClick() {
			let that = this;
			if (!that.userId) {
				that.$nextTick(() => {
					that.$router.push({
						path: "/"
					})
				})
			}
		},
		onRouteChanged() {
			let that = this;
			that.activeIndex = that.$route.path;
		},
		handleSelect(key, keyPath) {
			// this.changePanel(key);
		},
		changePanel(panel) {
			this.activeIndex = panel
			// this.$emit('changePanel', panel)
			let that = this;
			that.$router.push(panel)
		},
		goNews() {
			// 行业资讯：当前标签页跳转外部站点
			window.location.href = 'http://news.jiguangcloud.com/'
		},

		//开启弹框
		handleOpen() {
			this.dialogVisibles = true;
		},

		closeDialog() {
			this.dialogVisibles = false;
		},

		//修改密码
		updatePassword() {
			this.changePasswordVisibles = true;
		},

		closePasswordDialog() {
			this.changePasswordVisibles = false;
		},

		//退出
		async logout() {
			this.$confirm('确定退出吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.LogOut()
					.then((res) => {
						// location.href = this.$router.options.base + '/home';
						location.href = '/';
					})
					.catch(() => {
					})
			})
		},

		//头部下拉菜单跳转
		massiveCommand(command) {
			if (command == 'AIGC') {
				window.open('http://www.jiguangcloud.com/aigc/', '_blank');
			} else {
				if (command != 'advancedSearch') {
					if (getToken()) {
						let that = this;
						that.$nextTick(() => {
							that.$router.push({
								name: command
							})
						})
					} else {
						this.dialogVisibles = true;
					}
				} else {
					let that = this;
					that.$nextTick(() => {
						that.$router.push({
							name: command
						})
					})
				}
			}
		},
		toActiveMenuItem(item) { // 激活导航菜单
			this.activeIndex = item.titleName
			this.$router.push(item.activeUrl)
			this.dropDownShow = false
		},
		handleResize() {
			this.screenWidth = window.innerWidth;
		},
		handleSearch() {
			this.tableLoading = true;
			this.xhl_data = [];
			getUeage().then((res)=>{
				if (res.code == 0) {
					this.xhl_data.push({"a":"日账户解锁企业上限/剩余解锁企业次数","b":res.data.dayUnlockCount,"c":res.data.leftDayUnlockCount});
					this.xhl_data.push({"a":"最大公海池上限/当前账户公海池已使用次数","b":res.data.maxCustCount,"c":res.data.currentCustCount});
					this.xhl_data.push({"a":"会员到期时间","b": formatDateN(res.data.expireTime,0)});
				}
				this.tableLoading = false;
			}).catch((err) => {
                this.tableLoading = false;
            });


			// getTenant().then((res) => {
			// 	if (res.code == 0) {
			// 		this.dayUnlockCount=res.data.dayUnlockCount
			// 		this.maxCustCount=res.data.maxCustCount
			// 		this.expireTime=res.data.expireTime
			// 		this.tableLoading = false;
			// 	}

			// }).catch((err) => {
            //     this.tableLoading = false
            // });
			//获得公海池已添加的公司数量
			// var params={
			// 	pageNo: this.pageNum,
			// 	pageSize: this.pageSize,
			// },
			// params = { ...params };
			// var url = '';
			// let data = ''
			// let index = 0
			// for (let key in params) {
			// 	let value = params[key]
			// 	data += `${(index > 0) ? '&' : ''}${key}=${value}`
			// 	index++
			// }
			// if (data !== '') {
			// 	url += '?' + data
			// }
			// 获得所有用户已经解锁的企业
			// queryCustLeadsPage(url).then((res) => {
			// 	this.total1=res.data.total
			// });
			//获得当前用户已经解锁的企业
			// dataPage(url).then((res) => {
			// 	this.total=res.data.total
			// });
			// 获得该企业下账号数量
			// queryUserList(params).then((res) => {
			// 	this.qiyexizhanghugeshu=res.data.length
			// })
		}
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	}
}
</script>

<style scoped lang="css" src="../assets/lanhu4/index.css"/>
<style lang="less" scoped>
/deep/.my-menu {
	background-color: #ffffff00;

	* {
		font-size: 16px;
	}
}

/deep/.my-menu-disabled {
	opacity: 1 !important;
}

.navigation-head {
	width: 100%;
	height: 60px;
	background-color: white;
	display: flex;
	position: relative;
	justify-content: space-between;
}

.sidebar {
	position: fixed;
	background-color: #FFFFFF;
	top: 60px;
	width: 200px;
	height: 10800px;
	cursor: pointer;
}

.dropdown-customer {
	position: fixed;
	top: 20px;
	left: 240px;
	cursor: pointer;

	.customer {
		font-size: 16px;
		margin-left: 80px;
	}
}

.aigc {
	left: 930px !important;
}

.osint {
	left: 600px !important;
}
.huiyuan {
	position: absolute;
	left: calc(85% - 13%);
	font-size: 14px;
	color: #606266;
	cursor: pointer;
	margin-top: 4px;
}
.xhl {
	position: absolute;
	left: calc(95% - 13%);
	font-size: 14px;
	color: #606266;
	cursor: pointer;
	margin-top: 4px;
}

.xsl-ps {
	font-size: 12px;
    position: relative;
    top: 5px;
    color: grey;
}

.avatar-container {
	margin-left: calc(100% - 25% - 170px);

	.avatar-wrapper {
		margin-top: 5px;
		position: relative;
		display: flex;
		align-items: center;

		.el-avatar {
			background: hsla(0, 0%, 0%, 0);
		}

		.user-avatar {
			cursor: pointer;
			width: 40px;
			height: 40px;
			line-height: 40px;
			border-radius: 10px;
		}

		.user-name {
			margin-left: 5px;
			min-width: 50px;
			cursor: pointer;
			text-align: center;
		}

		.el-icon-caret-bottom {
			cursor: pointer;
			position: absolute;
			font-size: 20px;
		}
	}
}

.lang-select-dropdown {
	position: absolute;
	top: 30px;
	left: 0px;
	margin-right: -40px;
	padding: 0px;
	min-width: max-content;
	text-align: center;
}

a {
	text-decoration: none;
}

.router-link-active {
	text-decoration: none;
}

// //////////////////////////////////////////////////
.nav-col-l {
	display: flex;
	justify-content: center;
	height: 100%;
	align-items: center;
}

.nav-col {
	display: flex;
	justify-content: center;
	overflow: hidden;
}

.nav-drop-down {
	width: 100%;
	height: 60px;
	display: flex;
	justify-content:
		center;
	align-items: center;
	color: #156ee9;
	font-weight: bolder;
}

.nav-dropdown-menu {
	// background: #c2daff;
	// border: 1px solid #c2daff;

	.nav-dropdown-item {
		// color: #5b96ef;
	}

	.el-dropdown-menu__item--divided {
		// border-top: 1px solid #5b96ef;
	}

	.el-dropdown-menu__item--divided:before {
		// background-color: #5b96ef;
	}

	/deep/ .popper__arrow {
		// border-bottom-color: #c2daff;
	}

	/deep/ .popper__arrow:after {
		// border-bottom-color: #c2daff;
	}
}

.nav-logo {
	width: 60%;
}

@media screen and (max-width: 1000px) {
	.text-wrapper_3 {
		display: none;
	}
}

@media screen and (max-width: 767px) {
	.text-wrapper_2 {
		display: none;
	}
}

@media screen and (min-width: 767px) {
	#bars {
		display: none;
	}
}
</style>

<style scoped lang="css" src="../assets/lanhu4/index1.css"/>



// WEBPACK FOOTER //
// src/components/navigation.vue